module.exports = __webpack_public_path__ + "img/defaultImage.7883d0e5.png";